import React from 'react'
import { Box, Flex, space } from '@workday/canvas-kit-react'
import Layout from '@workday/canvas-kit-react-layout'

export const CenteredLayout = (props: any) => {
  return (
    <Box margin={space.xs} paddingBottom={space.xs}>
      <Layout gutter={0} capWidth>
        <Layout.Column columns={12}>
          <Flex flexDirection="column" rowGap={space.xs}>
            {props.children}
          </Flex>
        </Layout.Column>
      </Layout>
    </Box>
  )
}
